import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAppLogo } from 'services/common/common.service';
import { ICommonResponse } from 'services/types';

export const ThunkGetAppLogo = createAsyncThunk<ICommonResponse<string>>('common/getAppLogo', () =>
  getAppLogo().then(r => r.data),
);
